import ApiCollection              from '@widesk-core/models/ApiCollection';
import { Box }                    from '@chakra-ui/react';
import { Text }                   from '@chakra-ui/react';
import _capitalize                from 'lodash/capitalize';
import _sortBy                    from 'lodash/sortBy';
import { useTranslation }         from 'react-i18next';
import CodeTypePropertyValueModel from '@/models/services/code/CodeTypePropertyValueModel';
import dayjs                      from 'dayjs';
import React                      from 'react';

interface IScheduleListProps {
	codeTypePropertyValueCollection: ApiCollection<CodeTypePropertyValueModel>;
}

const ScheduleList = (props: IScheduleListProps) => {

	const { codeTypePropertyValueCollection } = props;

	const { t } = useTranslation();

	const sortedProperties = React.useMemo(() => _sortBy(codeTypePropertyValueCollection.models, m => JSON.parse(m.value).start), [codeTypePropertyValueCollection.models])

	if (codeTypePropertyValueCollection.length > 0) {
		return (
			<Box
				display="flex"
				flexDirection="column"
				gap="2px"
			>
				<Text className='poppins-semibold' >{t('pages.ticket.schedules.title')}</Text>
				{
					sortedProperties.map(ctpv => {
						const start = dayjs(JSON.parse(ctpv.value).start * 1000);
						const end = dayjs(JSON.parse(ctpv.value).end * 1000);
						
						return (
							<Box 
								key={ctpv.urn}
								display="flex"
								alignItems="center"
								gap="5px"
								flexWrap="wrap"
							>
								<Text>• {_capitalize(start.format('dddd DD MMMM HH:mm'))}</Text>
								<Text>-</Text>
								<Text>{end.format('HH:mm')}</Text>
							</Box>
						)
					})
				}
			</Box>
		)
	}

	return <></>;
}

export default ScheduleList